// extracted by mini-css-extract-plugin
export var button = "FileButton-module--button--LRoEi";